(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fuel.service:fuelSuppliersService
     *
     * @description
     *
     */
    angular
        .module('manageRoles')
        .service('ManageRoleService', ManageRoleService);

    function ManageRoleService(RemoteService,ManageRolesRequestFactory, ManageRolesAdaptorFactory) {

    	 var self = this;

         var model={
            rolesSearchCriteria: ManageRolesRequestFactory.getRolesSearchCriteria(),
            rolesList:[]
        };

         var component =
                         {categoryLabel:'childElements', uniqueField: 'valueFieldName'}


         self.getcomponent = function(){
        	 return component;
         };

         self.setRolesSearchCriteria = function (passRoleSearch) {
             var roleSearch = ManageRolesRequestFactory.getRolesSearchCriteria();
             roleSearch.startPosition = passRoleSearch.startPosition;
             roleSearch.pageSize = passRoleSearch.pageSize;
             roleSearch.roleName = (passRoleSearch.roleName == null ? null : (passRoleSearch.roleName.roleName === undefined ? passRoleSearch.roleName : passRoleSearch.roleName.roleName));
             roleSearch.status = (passRoleSearch.status == null ? null : passRoleSearch.status.value );
             roleSearch.visibleRolesOnly = "false";
             model.rolesSearchCriteria = roleSearch;
         };

         self.getRoles = function(successFn, errorFn){
             RemoteService.searchRoles(model.rolesSearchCriteria).then(
                 function (response) {
                     if(response.success && !!response.roleList){
                         successFn(response.roleList);
                     }
                 },
                 function (error) {
                     errorFn(error.msg[0]);
                 }
             );
         };

         self.saveRole = function (role, successFn, errorFn) {
             var saveRole = ManageRolesRequestFactory.getRoleForSave(role);
             saveRole.status = role.status === false ?"ACT":"INA";
             saveRole.visibility = role.visibility === false ?"N":"Y";
             RemoteService.saveRole(saveRole).then(
                 function (response) {
                     successFn(response);
                 },
                 function (error) {
                     errorFn(error.msg[0]);
                 }
             );
         };

         self.getNewRole = function () {
             return ManageRolesRequestFactory.getNewRole();
         };

        self.formatPrivilegesForMultiSelect = function (privileges) {
            return ManageRolesAdaptorFactory.adaptPrivileges(privileges);
        }

         self.deleteRole = function (role, successFn, errorFn) {
             var deleteRole = ManageRolesRequestFactory.getRoleDeleteReq(role);
             RemoteService.deleteRole(deleteRole).then(
                 function (response) {
                     successFn(response);
                 },
                 function (error) {
                     errorFn(error.msg[0]);
                 }
             );
         };

         self.getRoleForEdit = function(role){
             var editRole = ManageRolesRequestFactory.getRoleForSave(role);
             editRole.name = role.roleName;
             editRole.status = editRole.status==="Inactive"?true:false;
             editRole.visibility = role.roleVisibility === "YES"?true:false;
             editRole.remarks = role.roleRemarks;
             editRole.privileges = ManageRolesAdaptorFactory.adaptPrivilegesToDisplay(role.priviList);
             editRole.roleId = role.roleId;
             editRole.version = role.roleVersion;
             return editRole;
         };
    }
})();
